import { inject, Injectable } from '@angular/core';

import {
    BehaviorSubject,
    Observable,
} from 'rxjs';

import { FuseAlertService } from '@fuse/components/alert';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
    private _alertService = inject(FuseAlertService);
    private _message: BehaviorSubject<{message:string, errors: Array<string> |null } | null> = new BehaviorSubject(null);
    private _updateMessage: BehaviorSubject<string | null> = new BehaviorSubject(null);
    private _saveMessage: BehaviorSubject<string | null> = new BehaviorSubject(null);
    private isNotSent:boolean = true;
    private _updateAlertTimeout: ReturnType<typeof setTimeout>;
    private _saveAlertTimeout: ReturnType<typeof setTimeout>;
    private _errorAlertTimeout: ReturnType<typeof setTimeout>;

    get message$(): Observable<{message:string, errors: Array<string> | null }> {
        return this._message.asObservable();
    }

    get updateMessage$(): Observable<string>{
        return this._updateMessage.asObservable();
    }

    get saveMessage$(): Observable<string>{
        return this._saveMessage.asObservable();
    }

    async updateAlert(message:string){
        this._updateMessage.next(message)
        this._alertService.show('update-alert')
        if (this._updateAlertTimeout) {
            clearTimeout(this._updateAlertTimeout);
        }
        await new Promise((resolve)=>{
            this._updateAlertTimeout = setTimeout(()=>{
                resolve(this._alertService.dismiss('update-alert'));
            },5000);
        })
    }

    async saveAlert(message:string){
        this._saveMessage.next(message)
        this._alertService.show('save-alert')
        if (this._saveAlertTimeout) {
            clearTimeout(this._saveAlertTimeout);
        }
        await new Promise((resolve)=>{
            this._saveAlertTimeout = setTimeout(()=>{
                resolve(this._alertService.dismiss('save-alert'));
            },5000);
        })
    }

    async errorAlert(errorArray:Array<string> | null, message:string){
        if(this.isNotSent){
            this._message.next({message:message, errors:errorArray});
            this.isNotSent=false;
            this._alertService.show('error-alert');
            if (this._errorAlertTimeout) {
                clearTimeout(this._errorAlertTimeout);
            }
            await new Promise((resolve)=>{
                this._errorAlertTimeout = setTimeout(()=>{
                    this.isNotSent=true;
                    resolve(this._alertService.dismiss('error-alert'));
                },5000);
            })
        }else{
            return;
        }
    }
}
